var CsmOverlayType;
(function (CsmOverlayType) {
    CsmOverlayType["Light"] = "light";
    CsmOverlayType["LightStrong"] = "light-strong";
    CsmOverlayType["Dark"] = "dark";
    CsmOverlayType["DarkStrong"] = "dark-strong";
})(CsmOverlayType || (CsmOverlayType = {}));
var CsmOverlayScrollStrategy;
(function (CsmOverlayScrollStrategy) {
    CsmOverlayScrollStrategy["None"] = "none";
    CsmOverlayScrollStrategy["Close"] = "close";
    CsmOverlayScrollStrategy["Block"] = "block";
})(CsmOverlayScrollStrategy || (CsmOverlayScrollStrategy = {}));
var csmOverlayBlockScrollId = 'csm-block-scroll';
export { CsmOverlayType as C, CsmOverlayScrollStrategy as a, csmOverlayBlockScrollId as c };
